import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  /**
   * UX gate only — NOT a security boundary. `isAdmin` comes from AuthContext, which
   * hydrates it from localStorage, so any user can flip it in devtools and reach the
   * route. The real check is the backend's 403 on the admin-only endpoints; this only
   * exists so non-admins don't land on a page that would just show them an error.
   */
  requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/admin" />;
  }

  return <>{children}</>;
};

export default PrivateRoute;